import PrimaryButton from '@components/atoms/buttons/PrimaryButton';
import { Flex } from '@components/atoms/Flex';
import { Paragraph } from '@components/atoms/Typography';
import BREAKPOINTS from '@lib/constants/breakpoints';
import Link from 'next/link';
import { FC } from 'react';
import styled from 'styled-components';

const StyledBottomActionBar = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  border-top: 1px solid #ebebeb;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  align-items: center;
  min-height: 65px;
  padding: 10px 80px;
  box-shadow: 0 3px 9px 3px rgba(0, 0, 0, 0.05);
  justify-content: space-between;

  @media (max-width: ${BREAKPOINTS.medium}) {
    padding: 10px 24px;
  }
`;

const ActionWrapper = styled(Flex)`
  height: 100%;
  justify-content: space-between;
`;

const Button = styled(PrimaryButton)`
  height: 100%;
  min-width: 200px;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BREAKPOINTS.medium}) {
    min-width: 0;
  }
`;

const LeftLabelWrapper = styled(Flex)`
  /* @media (max-width: ${BREAKPOINTS.medium}) {
    display: none;
  } */
`;

const LeftLabelTextsContainer = styled.div`
  /* margin-left: 16px; */
`;

const SmallText = styled(Paragraph)`
  line-height: normal;
  text-transform: uppercase;
  font-size: 13px;
`;

const Text = styled(Paragraph)`
  font-weight: 600;
`;

interface Props {
  buttonLabel: string;
  className?: string;
  smallText?: string;
  text?: React.ReactNode;
  href?: string;
  loading?: boolean;
  onClickOnAction?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  pink?: boolean;
  disabled?: boolean
}

const BottomActionBar: FC<Props> = ({
  buttonLabel,
  className,
  smallText,
  text,
  onClickOnAction,
  loading,
  href,
  pink = true,
  disabled = false
}) => (
  <StyledBottomActionBar className={className}>
    <LeftLabelWrapper>
      <LeftLabelTextsContainer>
        {smallText && <SmallText>{smallText}</SmallText>}
        {text && <Text>{text}</Text>}
      </LeftLabelTextsContainer>
    </LeftLabelWrapper>
    <ActionWrapper>
      {(href && !disabled) ? (
        <Link href={href}>
          <a>
            <Button isLoading={loading} pink={pink} onClick={onClickOnAction}>
              {buttonLabel}
            </Button>
          </a>
        </Link>
      ) : (
        <Button isLoading={loading} disabled={disabled} pink onClick={onClickOnAction}>
          {buttonLabel}
        </Button>
      )}
    </ActionWrapper>
  </StyledBottomActionBar>
);

export default BottomActionBar;
